class Storage {
  private getItem(type: 'localStorage' | 'sessionStorage', key: string) {
    if (typeof window !== 'undefined') {
      const val = window[type].getItem(key);

      if (!val) {
        return val;
      }
      try {
        return JSON.parse(val);
      } catch {
        return val;
      }
    }
    return null;
  }

  private setItem(
    type: 'localStorage' | 'sessionStorage',
    key: string,
    value: any,
  ) {
    if (typeof window !== 'undefined') {
      let val: string;

      const storageData = this.getItem(type, key);
      if (typeof value === 'object') {
        val = JSON.stringify({ ...storageData, ...value });
      } else {
        val = value;
      }

      window[type].setItem(key, val);

      return true;
    }

    return false;
  }

  private removeItem(type: 'localStorage' | 'sessionStorage', key: string) {
    if (typeof window !== 'undefined') {
      window[type].removeItem(key);

      return true;
    }

    return false;
  }

  get session() {
    return {
      getItem: (key: string) => this.getItem('sessionStorage', key),
      setItem: (key: string, value: any) =>
        this.setItem('sessionStorage', key, value),
      removeItem: (key: string) => this.removeItem('sessionStorage', key),
    };
  }

  get local() {
    return {
      getItem: (key: string) => this.getItem('localStorage', key),
      setItem: (key: string, value: any) =>
        this.setItem('localStorage', key, value),
      removeItem: (key: string) => this.removeItem('localStorage', key),
    };
  }
}

const storage = new Storage();

export default storage;
